'use client';
import clsx from 'clsx';
import { useState } from 'react';

import cn from '@/lib/clsxm';

import Button from '@/components/@base/button';
import Carousel, { CarouselItem } from '@/components/@base/carousel';
import Container from '@/components/@base/container';
import XImage from '@/components/@base/x-image';
import Props from '@/components/app/product/components/banner/type';
import { Gallery } from '@/components/app/product/components/gallery';

import { DATA_CY_OTHER_IMAGES } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function Banner({
  cover,
  alternativeCover,
  sellable,
  galleries,
  hasDiscount,
}: Props) {
  const [showGallery, setShowGallery] = useState(false);
  return (
    <>
      <Container className='relative mx-auto px-4 md:px-0'>
        {galleries && galleries.length > 0 && (
          <Button
            data-cy={DATA_CY_OTHER_IMAGES}
            id='otherImages'
            Icon={
              <XImage
                src={imagesList.icons.galleryIcon}
                alt={productLocalization.otherImages}
              />
            }
            className={clsx(
              hasDiscount ? 'bottom-[54px] md:bottom-11' : 'bottom-11',
              'absolute left-7 z-50 h-[31px] w-[95px] gap-1.5 border border-[#7E899B] bg-[#404040CC] text-[10px]! font-medium! whitespace-nowrap text-white hover:bg-[#404040] md:bottom-[13px] md:left-3',
            )}
            onClick={() => setShowGallery(!showGallery)}
          >
            {productLocalization.otherImages}
          </Button>
        )}
        <Carousel
          autoplay={{
            delay: 6000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          slidesPerView={1}
          loop={true}
          spaceBetween={50}
          freeMode={false}
          className='[&_.swiper-slide]:overflow-hidden [&_.swiper-slide]:rounded-[10px]'
        >
          <CarouselItem className='overflow-hidden rounded-[10px] md:h-[360px]! md:w-[360px]!'>
            <XImage
              src={cover.publicLink}
              alt={cover.title}
              width={400}
              height={400}
              className={cn(sellable ? '' : 'blur-[2px]')}
            />
          </CarouselItem>
          <CarouselItem className='overflow-hidden rounded-[10px] md:h-[360px]! md:w-[360px]!'>
            <XImage
              src={alternativeCover.publicLink}
              alt={alternativeCover.title}
              width={400}
              height={400}
              className={cn(sellable ? '' : 'blur-[2px]')}
            />
          </CarouselItem>
        </Carousel>
      </Container>
      {showGallery && (
        <Gallery data={galleries} isOpen={showGallery} onClose={() => setShowGallery(false)} />
      )}
    </>
  );
}
